import actionTypes from "./actionTypes";

export const sidebarController = () => {
    return {
        type: actionTypes.SIDEBAR
    }
}